import styled from '@emotion/styled'

import { colors, NativeLink, spacing, typography } from 'main/ui'

export const Container = styled.div`
  align-items: center;
  border-bottom: 1px solid ${colors.border.default};
  border-top: 1px solid ${colors.border.default};
  display: flex;
  justify-content: space-between;
  padding: ${spacing.majorScale(1)}px;
`

export const LeftContainerContainer = styled.div`
  margin-left: ${spacing.majorScale(18)}px;
`

export const MoreInformationNativeLink = styled(NativeLink)`
  font-size: ${typography.fontSize.small};
  line-height: 20px;
`
